import React, { useState, useEffect } from 'react';
import { collection, query, getDocs, orderBy } from 'firebase/firestore';
import { db } from '../lib/firebase';
import type { CoachProfile } from '../types';
import { MapPin, Globe, Mail, Instagram, Facebook, Twitter, Linkedin, Search } from 'lucide-react';
import Select from 'react-select';
import { useTranslation } from '../i18n/useTranslation';

// List of all countries
const countries = [
  { value: 'Afghanistan', label: 'Afghanistan' },
  { value: 'Albania', label: 'Albania' },
  { value: 'Algeria', label: 'Algeria' },
  { value: 'Andorra', label: 'Andorra' },
  { value: 'Angola', label: 'Angola' },
  { value: 'Antigua and Barbuda', label: 'Antigua and Barbuda' },
  { value: 'Argentina', label: 'Argentina' },
  { value: 'Armenia', label: 'Armenia' },
  { value: 'Australia', label: 'Australia' },
  { value: 'Austria', label: 'Austria' },
  { value: 'Azerbaijan', label: 'Azerbaijan' },
  { value: 'Bahamas', label: 'Bahamas' },
  { value: 'Bahrain', label: 'Bahrain' },
  { value: 'Bangladesh', label: 'Bangladesh' },
  { value: 'Barbados', label: 'Barbados' },
  { value: 'Belarus', label: 'Belarus' },
  { value: 'Belgium', label: 'Belgium' },
  { value: 'Belize', label: 'Belize' },
  { value: 'Benin', label: 'Benin' },
  { value: 'Bhutan', label: 'Bhutan' },
  { value: 'Bolivia', label: 'Bolivia' },
  { value: 'Bosnia and Herzegovina', label: 'Bosnia and Herzegovina' },
  { value: 'Botswana', label: 'Botswana' },
  { value: 'Brazil', label: 'Brazil' },
  { value: 'Brunei', label: 'Brunei' },
  { value: 'Bulgaria', label: 'Bulgaria' },
  { value: 'Burkina Faso', label: 'Burkina Faso' },
  { value: 'Burundi', label: 'Burundi' },
  { value: 'Cabo Verde', label: 'Cabo Verde' },
  { value: 'Cambodia', label: 'Cambodia' },
  { value: 'Cameroon', label: 'Cameroon' },
  { value: 'Canada', label: 'Canada' },
  { value: 'Central African Republic', label: 'Central African Republic' },
  { value: 'Chad', label: 'Chad' },
  { value: 'Chile', label: 'Chile' },
  { value: 'China', label: 'China' },
  { value: 'Colombia', label: 'Colombia' },
  { value: 'Comoros', label: 'Comoros' },
  { value: 'Congo', label: 'Congo' },
  { value: 'Costa Rica', label: 'Costa Rica' },
  { value: 'Croatia', label: 'Croatia' },
  { value: 'Cuba', label: 'Cuba' },
  { value: 'Cyprus', label: 'Cyprus' },
  { value: 'Czech Republic', label: 'Czech Republic' },
  { value: 'Denmark', label: 'Denmark' },
  { value: 'Djibouti', label: 'Djibouti' },
  { value: 'Dominica', label: 'Dominica' },
  { value: 'Dominican Republic', label: 'Dominican Republic' },
  { value: 'Ecuador', label: 'Ecuador' },
  { value: 'Egypt', label: 'Egypt' },
  { value: 'El Salvador', label: 'El Salvador' },
  { value: 'Equatorial Guinea', label: 'Equatorial Guinea' },
  { value: 'Eritrea', label: 'Eritrea' },
  { value: 'Estonia', label: 'Estonia' },
  { value: 'Eswatini', label: 'Eswatini' },
  { value: 'Ethiopia', label: 'Ethiopia' },
  { value: 'Fiji', label: 'Fiji' },
  { value: 'Finland', label: 'Finland' },
  { value: 'France', label: 'France' },
  { value: 'Gabon', label: 'Gabon' },
  { value: 'Gambia', label: 'Gambia' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'Germany', label: 'Germany' },
  { value: 'Ghana', label: 'Ghana' },
  { value: 'Greece', label: 'Greece' },
  { value: 'Grenada', label: 'Grenada' },
  { value: 'Guatemala', label: 'Guatemala' },
  { value: 'Guinea', label: 'Guinea' },
  { value: 'Guinea-Bissau', label: 'Guinea-Bissau' },
  { value: 'Guyana', label: 'Guyana' },
  { value: 'Haiti', label: 'Haiti' },
  { value: 'Honduras', label: 'Honduras' },
  { value: 'Hungary', label: 'Hungary' },
  { value: 'Iceland', label: 'Iceland' },
  { value: 'India', label: 'India' },
  { value: 'Indonesia', label: 'Indonesia' },
  { value: 'Iran', label: 'Iran' },
  { value: 'Iraq', label: 'Iraq' },
  { value: 'Ireland', label: 'Ireland' },
  { value: 'Israel', label: 'Israel' },
  { value: 'Italy', label: 'Italy' },
  { value: 'Jamaica', label: 'Jamaica' },
  { value: 'Japan', label: 'Japan' },
  { value: 'Jordan', label: 'Jordan' },
  { value: 'Kazakhstan', label: 'Kazakhstan' },
  { value: 'Kenya', label: 'Kenya' },
  { value: 'Kiribati', label: 'Kiribati' },
  { value: 'Korea, North', label: 'Korea, North' },
  { value: 'Korea, South', label: 'Korea, South' },
  { value: 'Kosovo', label: 'Kosovo' },
  { value: 'Kuwait', label: 'Kuwait' },
  { value: 'Kyrgyzstan', label: 'Kyrgyzstan' },
  { value: 'Laos', label: 'Laos' },
  { value: 'Latvia', label: 'Latvia' },
  { value: 'Lebanon', label: 'Lebanon' },
  { value: 'Lesotho', label: 'Lesotho' },
  { value: 'Liberia', label: 'Liberia' },
  { value: 'Libya', label: 'Libya' },
  { value: 'Liechtenstein', label: 'Liechtenstein' },
  { value: 'Lithuania', label: 'Lithuania' },
  { value: 'Luxembourg', label: 'Luxembourg' },
  { value: 'Madagascar', label: 'Madagascar' },
  { value: 'Malawi', label: 'Malawi' },
  { value: 'Malaysia', label: 'Malaysia' },
  { value: 'Maldives', label: 'Maldives' },
  { value: 'Mali', label: 'Mali' },
  { value: 'Malta', label: 'Malta' },
  { value: 'Marshall Islands', label: 'Marshall Islands' },
  { value: 'Mauritania', label: 'Mauritania' },
  { value: 'Mauritius', label: 'Mauritius' },
  { value: 'Mexico', label: 'Mexico' },
  { value: 'Micronesia', label: 'Micronesia' },
  { value: 'Moldova', label: 'Moldova' },
  { value: 'Monaco', label: 'Monaco' },
  { value: 'Mongolia', label: 'Mongolia' },
  { value: 'Montenegro', label: 'Montenegro' },
  { value: 'Morocco', label: 'Morocco' },
  { value: 'Mozambique', label: 'Mozambique' },
  { value: 'Myanmar', label: 'Myanmar' },
  { value: 'Namibia', label: 'Namibia' },
  { value: 'Nauru', label: 'Nauru' },
  { value: 'Nepal', label: 'Nepal' },
  { value: 'Netherlands', label: 'Netherlands' },
  { value: 'New Zealand', label: 'New Zealand' },
  { value: 'Nicaragua', label: 'Nicaragua' },
  { value: 'Niger', label: 'Niger' },
  { value: 'Nigeria', label: 'Nigeria' },
  { value: 'North Macedonia', label: 'North Macedonia' },
  { value: 'Norway', label: 'Norway' },
  { value: 'Oman', label: 'Oman' },
  { value: 'Pakistan', label: 'Pakistan' },
  { value: 'Palau', label: 'Palau' },
  { value: 'Palestine', label: 'Palestine' },
  { value: 'Panama', label: 'Panama' },
  { value: 'Papua New Guinea', label: 'Papua New Guinea' },
  { value: 'Paraguay', label: 'Paraguay' },
  { value: 'Peru', label: 'Peru' },
  { value: 'Philippines', label: 'Philippines' },
  { value: 'Poland', label: 'Poland' },
  { value: 'Portugal', label: 'Portugal' },
  { value: 'Qatar', label: 'Qatar' },
  { value: 'Romania', label: 'Romania' },
  { value: 'Russia', label: 'Russia' },
  { value: 'Rwanda', label: 'Rwanda' },
  { value: 'Saint Kitts and Nevis', label: 'Saint Kitts and Nevis' },
  { value: 'Saint Lucia', label: 'Saint Lucia' },
  { value: 'Saint Vincent and the Grenadines', label: 'Saint Vincent and the Grenadines' },
  { value: 'Samoa', label: 'Samoa' },
  { value: 'San Marino', label: 'San Marino' },
  { value: 'Sao Tome and Principe', label: 'Sao Tome and Principe' },
  { value: 'Saudi Arabia', label: 'Saudi Arabia' },
  { value: 'Senegal', label: 'Senegal' },
  { value: 'Serbia', label: 'Serbia' },
  { value: 'Seychelles', label: 'Seychelles' },
  { value: 'Sierra Leone', label: 'Sierra Leone' },
  { value: 'Singapore', label: 'Singapore' },
  { value: 'Slovakia', label: 'Slovakia' },
  { value: 'Slovenia', label: 'Slovenia' },
  { value: 'Solomon Islands', label: 'Solomon Islands' },
  { value: 'Somalia', label: 'Somalia' },
  { value: 'South Africa', label: 'South Africa' },
  { value: 'South Sudan', label: 'South Sudan' },
  { value: 'Spain', label: 'Spain' },
  { value: 'Sri Lanka', label: 'Sri Lanka' },
  { value: 'Sudan', label: 'Sudan' },
  { value: 'Suriname', label: 'Suriname' },
  { value: 'Sweden', label: 'Sweden' },
  { value: 'Switzerland', label: 'Switzerland' },
  { value: 'Syria', label: 'Syria' },
  { value: 'Taiwan', label: 'Taiwan' },
  { value: 'Tajikistan', label: 'Tajikistan' },
  { value: 'Tanzania', label: 'Tanzania' },
  { value: 'Thailand', label: 'Thailand' },
  { value: 'Timor-Leste', label: 'Timor-Leste' },
  { value: 'Togo', label: 'Togo' },
  { value: 'Tonga', label: 'Tonga' },
  { value: 'Trinidad and Tobago', label: 'Trinidad and Tobago' },
  { value: 'Tunisia', label: 'Tunisia' },
  { value: 'Turkey', label: 'Turkey' },
  { value: 'Turkmenistan', label: 'Turkmenistan' },
  { value: 'Tuvalu', label: 'Tuvalu' },
  { value: 'Uganda', label: 'Uganda' },
  { value: 'Ukraine', label: 'Ukraine' },
  { value: 'United Arab Emirates', label: 'United Arab Emirates' },
  { value: 'United Kingdom', label: 'United Kingdom' },
  { value: 'United States', label: 'United States' },
  { value: 'Uruguay', label: 'Uruguay' },
  { value: 'Uzbekistan', label: 'Uzbekistan' },
  { value: 'Vanuatu', label: 'Vanuatu' },
  { value: 'Vatican City', label: 'Vatican City' },
  { value: 'Venezuela', label: 'Venezuela' },
  { value: 'Vietnam', label: 'Vietnam' },
  { value: 'Yemen', label: 'Yemen' },
  { value: 'Zambia', label: 'Zambia' },
  { value: 'Zimbabwe', label: 'Zimbabwe' }
];

export default function GoalieCoaches() {
  const { t } = useTranslation();
  const [coaches, setCoaches] = useState<CoachProfile[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedLanguage, setSelectedLanguage] = useState<string>('');
  const [selectedCountry, setSelectedCountry] = useState<string>('');
  const [citySearchTerm, setCitySearchTerm] = useState('');

  useEffect(() => {
    const fetchCoaches = async () => {
      try {
        const q = query(
          collection(db, 'coach_profiles'),
          orderBy('createdAt', 'desc')
        );
        
        const querySnapshot = await getDocs(q);
        const coachesData = querySnapshot.docs.map(doc => {
          const data = doc.data();
          return {
            id: doc.id,
            ...data,
            createdAt: data.createdAt?.toDate() || new Date(),
            updatedAt: data.updatedAt?.toDate() || new Date()
          };
        }) as CoachProfile[];

        setCoaches(coachesData);
      } catch (err) {
        console.error('Error fetching coaches:', err);
        setError(t('goalieCoaches.failedToLoad'));
      } finally {
        setLoading(false);
      }
    };

    fetchCoaches();
  }, []);

  const languages = Array.from(
    new Set(coaches.flatMap(coach => coach.languages))
  ).sort();

  const filteredCoaches = coaches.filter(coach => {
    const matchesSearch = searchTerm === '' || 
      coach.schoolName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      coach.coachName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      coach.description.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesLanguage = selectedLanguage === '' || 
      coach.languages.includes(selectedLanguage);

    const matchesCountry = selectedCountry === '' || 
      coach.country === selectedCountry;

    const matchesCity = citySearchTerm === '' || 
      coach.city.toLowerCase().includes(citySearchTerm.toLowerCase());

    return matchesSearch && matchesLanguage && matchesCountry && matchesCity;
  });

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#1b3968] mb-4"></div>
          <p className="text-gray-600">{t('goalieCoaches.loading')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className='max-w-7xl mx-auto px-4 py-8'>
      <div className='mb-8'>
        <h1 className='text-2xl md:text-3xl font-bold text-primary-600 mb-4 italic'>
          {t('goalieCoaches.title')}
        </h1>
        <p className='text-gray-600'>
          {t('goalieCoaches.subtitle')}
        </p>
      </div>

      {error ? (
        <div className='bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4'>
          {error}
        </div>
      ) : (
        <>
          <div className='glass-card p-6 mb-8'>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4'>
              <div>
                <label className='block text-sm font-medium text-gray-700 mb-1'>
                  {t('goalieCoaches.search')}
                </label>
                <div className='relative'>
                  <input
                    type='text'
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    placeholder={t('goalieCoaches.searchPlaceholder')}
                    className='pl-10 pr-4 py-2 w-full border border-gray-300 rounded-md focus:ring-[#1b3968] focus:border-[#1b3968]'
                  />
                  <Search className='absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400' />
                </div>
              </div>

              <div>
                <label className='block text-sm font-medium text-gray-700 mb-1'>
                  {t('goalieCoaches.language')}
                </label>
                <select
                  value={selectedLanguage}
                  onChange={(e) => setSelectedLanguage(e.target.value)}
                  className='w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-[#1b3968] focus:border-[#1b3968]'
                >
                  <option value=''>{t('goalieCoaches.allLanguages')}</option>
                  {languages.map((language) => (
                    <option key={language} value={language}>
                      {language}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className='block text-sm font-medium text-gray-700 mb-1'>
                  {t('goalieCoaches.country')}
                </label>
                <Select
                  value={
                    selectedCountry
                      ? { value: selectedCountry, label: selectedCountry }
                      : null
                  }
                  onChange={(option) => {
                    setSelectedCountry(option?.value || '');
                    // Reset city when country changes
                    setCitySearchTerm('');
                  }}
                  options={countries}
                  className='text-sm'
                  classNamePrefix='react-select'
                  placeholder={t('goalieCoaches.selectCountry')}
                  isClearable={true}
                  isSearchable={true}
                />
              </div>

              <div>
                <label className='block text-sm font-medium text-gray-700 mb-1'>
                  {t('goalieCoaches.city')}
                </label>
                <input
                  type='text'
                  value={citySearchTerm}
                  onChange={(e) => setCitySearchTerm(e.target.value)}
                  placeholder={t('goalieCoaches.searchByCity')}
                  className='w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-[#1b3968] focus:border-[#1b3968]'
                />
              </div>
            </div>
          </div>

          <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
            {filteredCoaches.map((coach) => (
              <div
                key={coach.id}
                className='glass-card overflow-hidden hover:shadow-xl transition-all duration-300 hover:scale-[1.02]'
              >
                <div className='aspect-w-16 aspect-h-9 bg-gray-100'>
                  <img
                    src={coach.logoUrl}
                    alt={`${coach.schoolName} logo`}
                    className='w-full h-full object-cover'
                  />
                </div>
                <div className='p-6'>
                  <h2 className='text-xl font-bold text-gray-900 mb-2'>
                    {coach.schoolName}
                  </h2>
                  <p className='text-gray-600 font-medium mb-4'>
                    {coach.coachName}
                  </p>

                  <div className='flex items-center gap-2 text-gray-600 mb-2'>
                    <MapPin className='h-4 w-4 flex-shrink-0' />
                    <span className='text-sm'>
                      {coach.city && coach.country
                        ? `${coach.city}, ${coach.country}`
                        : coach.city
                        ? coach.city
                        : coach.country
                        ? coach.country
                        : t('goalieCoaches.locationNotSpecified')}
                    </span>
                  </div>

                  <div className='mb-4'>
                    <h3 className='text-sm font-medium text-gray-700 mb-1'>
                      {t('goalieCoaches.languages')}
                    </h3>
                    <div className='flex flex-wrap gap-2'>
                      {coach.languages.map((language) => (
                        <span
                          key={language}
                          className='inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-primary-100 text-primary-800'
                        >
                          {language}
                        </span>
                      ))}
                    </div>
                  </div>

                  <p className='text-gray-600 mb-4 line-clamp-3'>
                    {coach.description}
                  </p>

                  <div className='mb-4'>
                    <h3 className='text-sm font-medium text-gray-700 mb-1'>
                      {t('goalieCoaches.strengths')}
                    </h3>
                    <div className='flex flex-wrap gap-2'>
                      {coach.strengths.map((strength) => (
                        <span
                          key={strength}
                          className='inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800'
                        >
                          {strength}
                        </span>
                      ))}
                    </div>
                  </div>

                  {coach.services.length > 0 && (
                    <div className='mb-4'>
                      <h3 className='text-sm font-medium text-gray-700 mb-1'>
                        {t('goalieCoaches.services')}
                      </h3>
                      <ul className='space-y-1'>
                        {coach.services.map((service, index) => (
                          <li
                            key={index}
                            className='flex justify-between text-sm'
                          >
                            <span>{service.name}</span>
                            <span className='text-gray-600'>
                              {service.price || t('goalieCoaches.contactForPrice')}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  <div className='flex items-center justify-between pt-4 border-t border-gray-200'>
                    <div className='flex space-x-3'>
                      {coach.socialLinks.website && (
                        <a
                          href={coach.socialLinks.website}
                          target='_blank'
                          rel='noopener noreferrer'
                          className='text-gray-400 hover:text-[#1b3968]'
                        >
                          <Globe className='h-5 w-5' />
                        </a>
                      )}
                      {coach.socialLinks.instagram && (
                        <a
                          href={coach.socialLinks.instagram}
                          target='_blank'
                          rel='noopener noreferrer'
                          className='text-gray-400 hover:text-[#1b3968]'
                        >
                          <Instagram className='h-5 w-5' />
                        </a>
                      )}
                      {coach.socialLinks.facebook && (
                        <a
                          href={coach.socialLinks.facebook}
                          target='_blank'
                          rel='noopener noreferrer'
                          className='text-gray-400 hover:text-[#1b3968]'
                        >
                          <Facebook className='h-5 w-5' />
                        </a>
                      )}
                      {coach.socialLinks.twitter && (
                        <a
                          href={coach.socialLinks.twitter}
                          target='_blank'
                          rel='noopener noreferrer'
                          className='text-gray-400 hover:text-[#1b3968]'
                        >
                          <Twitter className='h-5 w-5' />
                        </a>
                      )}
                      {coach.socialLinks.linkedin && (
                        <a
                          href={coach.socialLinks.linkedin}
                          target='_blank'
                          rel='noopener noreferrer'
                          className='text-gray-400 hover:text-[#1b3968]'
                        >
                          <Linkedin className='h-5 w-5' />
                        </a>
                      )}
                    </div>
                    <a
                      href={`mailto:${coach.email}`}
                      className='inline-flex items-center text-[#1b3968] hover:text-[#1b3968]/80'
                    >
                      <Mail className='h-5 w-5 mr-1' />
                      {t('goalieCoaches.contact')}
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filteredCoaches.length === 0 && (
            <div className='text-center py-12 bg-gray-50 rounded-lg'>
              <p className='text-gray-600'>
                {t('goalieCoaches.noCoachesFound')}
              </p>
            </div>
          )}
        </>
      )}
    </div>
  );
}